export default "__VITE_ASSET__BjgAdugf__"